import EventBus from "./event-bus";
import {errorHandler} from "./common";

const axios = require('axios');

export function registerNotices(notices) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    EventBus.$emit("showLoading", true);
    axios.post(process.env.ROOT_API + 'admin/notices', JSON.stringify(notices), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log("Send Notices");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}

export function getNoticeHistory(from, to) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/notices?from='+from+"&to="+to, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log("Send Notices");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}



// WEBPACK FOOTER //
// ./src/api/notice.js